export default class TicketCommentaireController {
	/* @ngInject */
	constructor($translate) {
		this.$translate = $translate;
	}

	$onInit() {
		this.resolve.commentList.forEach((comment) => {
			comment.commentBody = comment.commentBody.replace(/\n/g, '<br>');
		});
	}

	close() {
		this.modalInstance.dismiss('close');
	}
}
